"use client";

import { allBrandList } from "@/components/BrandDetail/arraybrandlist";
import Loader from "@/components/Loader";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import PDFIcon from "@/icons/PDFIcon";
import { cn, formatISODate, getBrandImage, isRebateExpired } from "@/lib/utils";
import { useGetRebatesListQuery } from "@/redux/apiSlices/supportApi";
import { useQueryParams } from "@/utils/useQueryParams";
import Link from "next/link";
import DynamicImage from "../DynamicImages/DynamicImage";

const FindShowroom = ({ brandName }) => {
  // Fetch brand data based on brandName
  const DataResponse = allBrandList.find((item) => item[brandName])?.[
    brandName
  ];

  const { limit, page } = useQueryParams();

  const { data, isFetching } = useGetRebatesListQuery({
    page,
    limit,
    brandIds: DataResponse?.id,
    search: "",
    categoryIds: "",
    validUntil: "",
    isExpired: "",
    sort: "",
    order: "",
  });

  const { data: rebatesList = [], pagination = {} } = data || {};

  const brandNameMapping = new Map([
    ["U_Line", "U-Line"],
    ["Lg", "LG"],
    ["Lg_Studio", "LG Studio"],
    ["Kitchenaid", "KitchenAid"],
    ["Ge_Profile", "GE Profile"],
    ["Ge_Appliances", "GE"],
  ]);

  const formattedBrandName =
    brandNameMapping.get(brandName) ||
    brandName
      .replace(/Appliances/g, "")
      .replace(/_/g, " ")
      .trim();

  return (
    <>
      {" "}
      {isFetching ? (
        <Loader />
      ) : (
        <>
          {rebatesList && rebatesList.length !== 0 && (
            <div className="py-[52px] px-[20px] bg-[#f5f5f7]">
              <div className="max-w-[1410px] mx-auto gap-8">
                <h2 className="text-[30px] font-semibold mb-4">
                  <span className="  text-[#ca082e]">Additional Savings.</span>{" "}
                  Explore {formattedBrandName} Rebates
                </h2>
                <div>
                  <Carousel opts={{ align: "start" }} className="w-full">
                    <CarouselContent>
                      {rebatesList.map((rebate, index) => (
                        <CarouselItem
                          className="basis-1/4 m-0 mlg:basis-1/3 md:basis-5/12 sm:basis-6/12 mob:basis-8/12 xsm:basis-full"
                          key={index}
                        >
                          <div className="border border-gray1 rounded-[15px] p-5 ml-4 bg-white">
                            <div className="h-auto relative w-full mb-5 max-w-[145px]">
                              <div className="flex justify-center items-center gap-3 relative w-full ">
                                {rebate?.brandNames?.length &&
                                  rebate?.brandNames?.map(
                                    ({ brandImage, brandId, brandName }) => (
                                      <div
                                        key={brandId}
                                        className="h-[60px] relative w-full flex justify-center items-center"
                                      >
                                        <DynamicImage
                                          src={brandImage}
                                          alt="Image"
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            if (
                                              e.target &&
                                              e.target.parentNode
                                            ) {
                                              e.target.outerHTML = ` <img className="object-contain " src=${getBrandImage(
                                                brandName
                                              )}/>`;
                                            }
                                          }}
                                          fill
                                          className="object-contain"
                                        />
                                      </div>
                                    )
                                  )}
                              </div>
                            </div>
                            <div className="px-[7px] text-[13px] leading-[20px] text-blue2 grid">
                              <div className="mb-2 lg:mb-3 min-h-10 text-[14px]">
                                <h2 className="font-semibold two-line-dots text-[15px] h-[40px] two-line-ellipsis mb-2">
                                  {rebate?.title}
                                </h2>
                                <p className="mb-3 min-h-[60px] three-line-dots text-[13px]">
                                  {rebate?.description}
                                </p>
                                <p className="text-[12px]">
                                  Valid from{" "}
                                  {formatISODate(
                                    rebate?.startDate,
                                    "MM/dd/yyyy"
                                  )}{" "}
                                  to{" "}
                                  {formatISODate(rebate?.endDate, "MM/dd/yyyy")}
                                </p>
                              </div>
                              {!isRebateExpired(rebate?.endDate) &&
                              rebate?.rebateItemsCount > 0 ? (
                                <Link
                                  href={`/products?brandIds=${DataResponse?.id}&rebateIds=${rebate?.id}`}
                                  className="font-medium px-2 text-center text-[13px] flex justify-center items-center border border-blue2 rounded-[8px] min-h-14 mb-[14px] w-full lg:h-[42px] lg:min-h-[auto] hover:bg-gray1"
                                >
                                  Shop Models in this Rebate
                                </Link>
                              ) : (
                                <button
                                  onClick={() => {
                                    if (collection.link)
                                      window.location.href = collection.link;
                                  }}
                                  className={cn(
                                    "font-medium px-2 text-center text-[13px] flex justify-center items-center border border-blue2 rounded-[8px] min-h-14 mb-[14px] w-full lg:h-[42px] lg:min-h-[auto] hover:bg-gray1 bg-gray-200 text-gray-500 cursor-not-allowed",
                                    rebate.rebateItemsCount === 0 &&
                                      "invisible"
                                  )}
                                  disabled={true}
                                >
                                  Expired Rebate
                                </button>
                              )}
                              <Link
                                href={rebate?.formUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className=" justify-center mx-0 my-auto inline-flex gap-[10px] p-0 bg-transparent hover:bg-transparent text-blue2 h-6 text-[12px] leading-[22px]"
                              >
                                <PDFIcon />
                                Download Rebate Form
                              </Link>
                            </div>
                          </div>
                        </CarouselItem>
                      ))}
                    </CarouselContent>
                    <CarouselPrevious />
                    <CarouselNext />
                  </Carousel>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default FindShowroom;
